import * as angular from 'angular';

import { EmbedViewerLayoutController } from './embed-viewer-layout.controller';

export const EmbedViewerLayoutComponent: angular.IComponentOptions = {
  bindings: {
    initialLayout: '<',
    isCaptureMode: '<',
  },
  controller: EmbedViewerLayoutController,
  controllerAs: 'ctrl',
};
